import { FC } from "react";

import { Button, Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";

import { Content } from "../../../components/Content";
import { ContractItemModal } from "../components/ContractItemModal";
import { IItem } from "../../../types";

import { ActionFunction } from "../../../components/ActionColumn";
import { PageHeader } from "../../../components/PageHeader";
import { formatters } from "../../../utils/formatters";
import { getContractItems } from "../../../services/repositories";
import { ActionTable } from "../../../components/ActionTable";
import { useDelete, useModal, usePagination } from "../../../hooks";

const ContractItems: FC = () => {
  const {
    data: contractItems,
    isLoading: loading,
    pagination,
    handleRefreshData,
  } = usePagination(getContractItems);

  const {
    data: contractItem,
    isOpen,
    handleCloseModal,
    handleOpenModal,
  } = useModal<IItem>(handleRefreshData);

  const { handleDeleteData } = useDelete(handleRefreshData);

  const actions: ActionFunction<IItem> = (record) => {
    return [
      {
        key: "1",
        icon: <EditOutlined />,
        label: "Editar",
        onClick: () => handleOpenModal(record),
      },
      {
        key: "2",
        icon: <DeleteOutlined />,
        label: "Deletar",
        danger: true,
        onClick: () =>
          handleDeleteData(
            `/contracts/${record.meta?.pivot_contract_id}/items/${record.id}`,
            "Deseja deletar o local?"
          ),
      },
    ];
  };

  const columns: ColumnsType<IItem> = [
    {
      title: "Numero",
      dataIndex: "meta",
      key: "number",
      render: ({ pivot_number }) => <Tag>{pivot_number}</Tag>,
      width: 100,
    },
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
      ellipsis: true,
    },
    {
      title: "Quantidade",
      dataIndex: "meta",
      key: "quantity",
      width: 120,
      render: ({ pivot_quantity }) => pivot_quantity,
    },
    {
      title: "Uso",
      dataIndex: "meta",
      key: "usage",
      width: 120,
      render: ({ pivot_usage }) => pivot_usage,
    },
    {
      title: "Valor",
      dataIndex: "meta",
      key: "value",
      render: ({ pivot_value }) => formatters.currency(pivot_value),
      width: 120,
    },
  ];

  return (
    <Content>
      <ContractItemModal
        isModalOpen={isOpen}
        data={contractItem}
        onClose={handleCloseModal}
        onRefreshData={handleRefreshData}
      />
      <PageHeader
        style={{ boxShadow: "none", padding: 0, marginBottom: "16px" }}
        width="100%"
        backButton={false}
        title={"Itens de serviços"}
        actions={[
          <Button
            key={"add_item_contract"}
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => handleOpenModal()}
          >
            Adicionar Item
          </Button>,
        ]}
      />
      <ActionTable
        pagination={pagination}
        loading={loading}
        actions={actions}
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={contractItems}
      />
    </Content>
  );
};

export { ContractItems };
